import { GEO_PREF_COOKIE, dispatchGeoPrefUpdated } from "@/lib/geo/geo-pref";

/** Read raw `geo_pref` value from `document.cookie` (browser only). */
export function readGeoPrefCookieRaw(): string | undefined {
	if (typeof document === "undefined") return undefined;
	const m = document.cookie.match(new RegExp(`(?:^|; )${GEO_PREF_COOKIE}=([^;]*)`));
	return m ? decodeURIComponent(m[1]) : undefined;
}

export type SetGeoPrefCookieParams = {
	locale: string;
	channel: string;
};

/**
 * Writes `geo_pref` JSON (locale, channel).
 * Dispatches `eurolabs-peptides-geo-pref-updated` for client listeners (e.g. cart pricing).
 */
export function setGeoPrefCookie(params: SetGeoPrefCookieParams): void {
	const payload = {
		locale: params.locale,
		channel: params.channel.trim().toLowerCase(),
	};
	document.cookie = `${GEO_PREF_COOKIE}=${encodeURIComponent(JSON.stringify(payload))}; path=/; max-age=${365 * 86400}; samesite=lax`;
	dispatchGeoPrefUpdated();
}
